import axios from 'axios'

const instance = axios.create({
   // Для локального стенда: REACT_APP_API_URL=http://localhost:4444/
   baseURL: process.env.REACT_APP_API_URL || 'https://api.speaksy.com.ua/'
})

instance.interceptors.request.use((config) => {
   config.headers.Authorization = window.localStorage.getItem('token')

   return config
})

// Адмін закрив доступ (вчитель): прибираємо токен і повертаємо на вхід
instance.interceptors.response.use(undefined, (error) => {
   if (error?.response?.data?.blocked && window.localStorage.getItem('token')) {
      window.localStorage.removeItem('token')
      window.location.assign('/')
   }
   return Promise.reject(error)
})

export default instance